import router from "@/router";
import { i18n } from "../../main";

import {
  getAffiliates,
  changeStatusAffiliate,
  getAffiliatesPrograms,
  changeStatusAffiliateProgram,
  postAffiliate,
  importAffiliates,
  createAffiliateProgram,
  getAffiliatesByProgramId,
  changeProgramAffiliate,
  getInfoProgramByProgramId,
  logInAffiliate,
  getSaleByAffiliateId,
  changePasswordAffiliate,
  getTerms,
  getDocTerm,
  signDoc,
  getProgramListByAffiliateId,
  getInfoPreRegister,
  registerAffiliate,
  sendEmailRecoverPassword,
  recoveryPassword,
  editAffiliate,
  getRanking,
  resendEmail,
  postCoupon,
  getSalesByAffiliateConsumer,
  editProgramTickets,
} from "@/api";

const state = {
  allAffiliates: [],
  affiliatesLoading: false,

  allAffiliatesPrograms: [],
  affiliatesProgramsLoading: false,

  stepProgram: 1,
  dataProgram: {
    name: "",
    slug: "",
    taxCommission: "",
    valueDiscount: "",
    percDiscount: "",
    typeCommission: "",
    limit: 0,
    emails: [],
    affiliates: [],
    products: [],
    product: "",
    status: "",
  },

  dialogInsertAffiliate: false,
  dialogResendEmail: false,
  dialogEditTicket: false,

  affiliatesByProgram: [],
  idProgramTemp: "",

  sale: [],
  loadingSale: false,

  terms: [],
  docTerm: null,

  affiliateProgramList: [],
  dataPreRegister: null,

  registerLoading: false,
  dialogPreRegister: false,

  dialogMyAccount: false,

  ranking: [],
  loadingRanking: false,

  affiliatesToResendEmail: [],
  tmpIdToResendEmail: "",

  dialogCoupon: false,
  infoDialogCoupon: null,

  salesByAffiliateConsumer: [],
  loadingSalesByAffiliateConsumer: false,
};

const getters = {
  allAffiliates: state => state.allAffiliates,
  affiliatesLoading: state => state.affiliatesLoading,

  allAffiliatesPrograms: state => state.allAffiliatesPrograms,
  affiliatesProgramsLoading: state => state.affiliatesProgramsLoading,

  stepProgram: state => state.stepProgram,
  dataProgram: state => state.dataProgram,

  dialogInsertAffiliate: state => state.dialogInsertAffiliate,
  dialogResendEmail: state => state.dialogResendEmail,
  dialogEditTicket: state => state.dialogEditTicket,

  affiliatesByProgram: state => state.affiliatesByProgram,
  idProgramTemp: state => state.idProgramTemp,

  sale: state => state.sale,
  loadingSale: state => state.loadingSale,

  terms: state => state.terms,
  docTerm: state => state.docTerm?.[0]?.texto,

  affiliateProgramList: state => state.affiliateProgramList,
  dataPreRegister: state => state.dataPreRegister,

  registerLoading: state => state.registerLoading,
  dialogPreRegister: state => state.dialogPreRegister,

  dialogMyAccount: state => state.dialogMyAccount,

  ranking: state => state.ranking,
  loadingRanking: state => state.loadingRanking,

  affiliatesToResendEmail: state => state.affiliatesToResendEmail,
  tmpIdToResendEmail: state => state.tmpIdToResendEmail,

  dialogCoupon: state => state.dialogCoupon,
  infoDialogCoupon: state => state.infoDialogCoupon,

  salesByAffiliateConsumer: state => state.salesByAffiliateConsumer,
  loadingSalesByAffiliateConsumer: state =>
    state.loadingSalesByAffiliateConsumer,
};

const actions = {
  async logInAffiliate({ commit, dispatch }, params) {
    const { email, senha } = params;
    let recaptcha = "";
    if (process.env.NODE_ENV === "production") {
      recaptcha = await window.grecaptcha.getResponse();
      if (recaptcha == "") {
        window.grecaptcha.reset();
        return;
      }
    }
    commit("setAffiliatesLoading", true);
    logInAffiliate(email, senha, recaptcha)
      .then(response => {
        if (response.data && response.data.access_token) {
          let dados = response.data.info;
          dispatch("setUserType", dados?.user_type);
          dispatch("setUserInfo", dados);
          document.cookie = `oe_jwt=${response.data.access_token}; path=/`;
          localStorage.setItem("oe_user_info", JSON.stringify(dados));
          router.push("/home");
        }
        commit("setAffiliatesLoading", false);
      })
      .finally(() => {
        if (process.env.NODE_ENV === "production") {
          window.grecaptcha.reset();
        }
      });
  },
  changePasswordAffiliate({ commit, dispatch }, params) {
    const { id, oldPass, newPass } = params;
    commit("setAffiliatesLoading", true);
    changePasswordAffiliate(id, oldPass, newPass).then(() => {
      commit("setAffiliatesLoading", false);
      dispatch("showSnackbarSuccess", "Senha alterada com sucesso!");
      router.push("/home");
    });
  },
  fetchAllAffiliates({ commit }, params) {
    const { loja, limite, pagina, status, name, ...rest } = params;
    commit("setAffiliatesLoading", true);
    getAffiliates(loja, limite, pagina, status, name, rest).then(response => {
      commit("setAllAffiliates", response.data);
      commit("setAffiliatesLoading", false);
    });
  },
  changeAffiliateStatus({ commit }, params) {
    const { id, status } = params;
    commit("setAffiliatesLoading", true);
    changeStatusAffiliate(id, status).then(() => {
      getAffiliates().then(response => {
        commit("setAllAffiliates", response.data);
        commit("setAffiliatesLoading", false);
      });
    });
  },
  fetchAffiliatesPrograms({ commit }, params) {
    const { limite, pagina, status, name, data_inicial, data_final, ...rest } =
      params;
    commit("setAffiliatesProgramsLoading", true);
    getAffiliatesPrograms(
      limite,
      pagina,
      status,
      name,
      data_inicial,
      data_final,
      rest
    ).then(response => {
      commit("setAllAffiliatesPrograms", response.data);
      commit("setAffiliatesProgramsLoading", false);
    });
  },
  changeAffiliateProgramStatus({ commit }, params) {
    const { id, status } = params;
    commit("setAffiliatesProgramsLoading", true);
    changeStatusAffiliateProgram(id, status).then(() => {
      getAffiliatesPrograms().then(response => {
        commit("setAllAffiliatesPrograms", response.data);
        commit("setAffiliatesProgramsLoading", false);
      });
    });
  },

  async importAffiliates({ commit, dispatch }, params) {
    commit("setAffiliatesLoading", true);
    try {
      const response = await importAffiliates(params);
      const result = response.data;
      if (!result.sucesso && result.info == "duplicate_email")
        dispatch(
          "showSnackbarError",
          i18n.t("sales.affiliate_email_error_import") +
            result.emails +
            i18n.t("sales.affiliate_email_duplicated_import")
        );
      commit("setDialogPreRegister", true);
      commit("setAffiliatesLoading", false);
      if (!result.sucesso && result.info == "already_registered_email")
        dispatch(
          "showSnackbarError",
          i18n.t("sales.affiliate_email_error_import") +
            result.emails +
            i18n.t("sales.affiliate_email_registered_import")
        );
      commit("setDialogPreRegister", true);
      commit("setAffiliatesLoading", false);
      if (result.sucesso) {
        dispatch(
          "showSnackbarSuccess",
          i18n.t("sales.affiliate_import_success")
        );
        commit("setAffiliatesLoading", false);
        commit("setDialogPreRegister", false);
        getAffiliates().then(response => {
          commit("setAllAffiliates", response.data);
        });
      }
    } catch (error) {
      dispatch("showSnackbarError", i18n.t("sales.affiliate_import_error"));
      commit("setAffiliatesLoading", false);
    }
  },
  createAffiliate({ commit, dispatch }, params) {
    const { nome, email, telefone, cpf, slug, status } = params;
    commit("setAffiliatesLoading", true);
    postAffiliate([{ nome, email, telefone, cpf, slug, status }])
      .then(() => {
        dispatch(
          "showSnackbarSuccess",
          i18n.t("sales.new_affiliate_success_message")
        );
        commit("setAffiliatesLoading", false);
        getAffiliates().then(response => {
          commit("setAllAffiliates", response.data);
        });
      })
      .catch(() => {
        dispatch(
          "showSnackbarError",
          i18n.t("sales.new_affiliate_error_message")
        );
        commit("setAffiliatesLoading", false);
      });
  },
  createAffiliateProgram({ commit }, params) {
    const {
      nome,
      slug,
      taxa_comissao,
      valor_desconto,
      perc_desconto,
      tipo_comissao,
      limite,
      emails,
      idproduto,
      nidproduto_variacao,
      status,
    } = params;
    commit("setAffiliatesProgramsLoading", true);
    createAffiliateProgram(
      nome,
      slug,
      taxa_comissao,
      valor_desconto,
      perc_desconto,
      tipo_comissao,
      limite,
      emails,
      idproduto,
      nidproduto_variacao,
      status
    ).then(() => {
      getAffiliatesPrograms().then(response => {
        commit("setAllAffiliatesPrograms", response.data);
        commit("setAffiliatesProgramsLoading", false);
      });
    });
  },
  nextStepProgram({ commit, state }) {
    commit("setStepProgram", state.stepProgram + 1);
  },
  stepBackProgram({ commit, state }) {
    commit("setStepProgram", state.stepProgram - 1);
  },

  changeDialogEditTicket({ commit, dispatch }, params) {
    const { idprograma, variacoes } = params;
    editProgramTickets(idprograma, variacoes)
      .then(() => {
        dispatch(
          "showSnackbarSuccess",
          i18n.t("sales.affiliates_program_tickets_success")
        );
        commit("toggleDialogEditTicket");
      })
      .catch(() => {
        dispatch(
          "showSnackbarError",
          i18n.t("sales.affiliates_program_tickets_error")
        );
      });
  },
  changeDialogInsertAffiliate({ commit, state }, params) {
    const { idprograma } = params;
    if (!state.dialogInsertAffiliate) {
      getAffiliatesByProgramId(idprograma).then(response => {
        commit("setAffiliatesByProgram", response.data);
        commit("setIdProgramTemp", idprograma);
      });
    } else {
      commit("setAffiliatesByProgram", []);
      commit("setIdProgramTemp", "");
    }
    commit("setDialogInsertAffiliates", !state.dialogInsertAffiliate);
  },
  changeDialogResendEmail({ commit, state, dispatch }, params) {
    const { idprograma } = params;
    commit("setTmpIdToResendEmail", idprograma);
    if (!state.dialogResendEmail) {
      getAffiliatesByProgramId(idprograma).then(response => {
        commit("setAffiliatesToResendEmail", response.data);
      });
    } else {
      commit("setAffiliatesToResendEmail", []);
      commit("setTmpIdToResendEmail", "");
      dispatch("cleanStates");
    }
    commit("setDialogResendEmail", !state.dialogResendEmail);
  },
  changeProgramAffiliate({ commit }, params) {
    const { idprograma, emails } = params;
    commit("setAffiliatesProgramsLoading", true);
    changeProgramAffiliate(idprograma, emails).then(() => {
      getAffiliatesPrograms().then(response => {
        commit("setAllAffiliatesPrograms", response.data);
        commit("setAffiliatesProgramsLoading", false);
      });
    });
  },

  getInfoProgram({ commit }, params) {
    const { id } = params;
    getInfoProgramByProgramId(id).then(response => {
      const program = response.data;
      commit("setDataProgram", program);
    });
  },

  getAffiliatesByProgram({ commit }, params) {
    const { id } = params;
    getAffiliatesByProgramId(id).then(response => {
      const affiliates = response.data;
      commit("setAffiliatesByProgram", affiliates);
    });
  },
  cleanStates({ commit }) {
    commit("setStepProgram", 1);
    commit("setAffiliatesByProgram", []);
    commit("setIdProgramTemp", "");
    commit("setDataProgram", {
      name: "",
      slug: "",
      taxCommission: "",
      valueDiscount: "",
      percDiscount: "",
      typeCommission: "",
      limit: 0,
      emails: [],
      affiliates: [],
      products: [],
      product: "",
      status: "",
    });
  },
  fetchSaleByAffiliateId({ commit }, params) {
    const { id, pesquisar } = params;
    commit("setSaleLoading", true);
    getSaleByAffiliateId(id, pesquisar).then(response => {
      const sale = response.data;
      commit("setSale", sale);
      commit("setSaleLoading", false);
    });
  },
  fetchTerms({ commit }, params) {
    const { idafiliado } = params;
    getTerms(idafiliado).then(response => {
      const terms = response.data;
      commit("setTerms", terms);
    });
  },
  fetchDocTerm({ commit }) {
    getDocTerm().then(response => {
      const term = response.data;
      commit("setDocTerm", term);
    });
  },
  signDocument({ dispatch, getters, commit }, params) {
    const { idprogramaafiliado } = params;
    signDoc(idprogramaafiliado)
      .then(() => {
        dispatch("showSnackbarSuccess", "Termo assinado com sucesso!");
        dispatch("fetchTerms", { idafiliado: getters.userInfo.idafiliado });
      })
      .catch(error => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === "É necessário preencher o cadastro!"
        ) {
          commit("setDialogMyAccount", true);
          dispatch(
            "showSnackbarError",
            "É necessário preencher o cadastro antes de assinar o documento."
          );
        } else {
          console.error("Erro ao assinar o documento:", error);
        }
      });
  },
  fetchProgramListByAffiliateId({ commit }, params) {
    const { idafiliado } = params;
    getProgramListByAffiliateId(idafiliado).then(response => {
      const programs = response.data;
      commit("setAffiliateProgramList", programs);
    });
  },
  fetchInfoPreRegister({ commit }, params) {
    const { id } = params;
    getInfoPreRegister(id).then(response => {
      const data = response.data;
      if (response.data.cadastro_preenchido) {
        document.cookie = `oe_jwt=""; path=/`;
        localStorage.clear();
        router.push({ name: "login" });
      } else {
        commit("setDataPreRegister", data);
      }
    });
  },
  registerAffiliate({ commit, dispatch }, params) {
    const {
      idprogramaafiliado,
      nome,
      email,
      telefone,
      cpf,
      slug,
      senha,
      termo,
    } = params;
    commit("setRegisterLoading", true);
    registerAffiliate(
      idprogramaafiliado,
      nome,
      email,
      telefone,
      cpf,
      slug,
      senha,
      termo
    ).then(() => {
      commit("setRegisterLoading", false);
      dispatch("showSnackbarSuccess", "Cadastro realizado com sucesso!");
      document.cookie = `oe_jwt=""; path=/`;
      localStorage.clear();
      router.push("/");
    });
  },
  sendEmailRecoverPassword({ dispatch }, params) {
    const { email, url } = params;
    let recaptcha = "";
    if (process.env.NODE_ENV === "production") {
      recaptcha = window.grecaptcha.getResponse();
      if (recaptcha == "") {
        window.grecaptcha.reset();
        return;
      }
    }
    sendEmailRecoverPassword(email, url, recaptcha).then(() => {
      dispatch("showSnackbarSuccess", "E-mail enviado com sucesso!");
      router.push("/");
    });
  },
  recoveryPassword({ dispatch }, params) {
    const { email, senha, token } = params;
    recoveryPassword(email, senha, token).then(() => {
      dispatch("showSnackbarSuccess", "Senha alterada com sucesso!");
      router.push("/");
    });
  },

  changeDialogMyAccount({ commit, state }) {
    commit("setDialogMyAccount", !state.dialogMyAccount);
  },

  editAffiliate({ commit, dispatch, getters }, params) {
    const { id, nome, telefone, cpf, slug } = params;
    commit("setAffiliatesLoading", true);

    editAffiliate(id, nome, telefone, cpf, slug).then(() => {
      commit("setAffiliatesLoading", false);
      dispatch("showSnackbarSuccess", "Cadastro alterado com sucesso!");
      const updatedUserInfo = {
        ...getters.userInfo,
        nome,
        telefone,
        cpf,
        slug,
      };

      commit("setUserInfo", updatedUserInfo);
    });
  },
  fetchRanking({ commit }, params) {
    const { idprograma } = params;
    commit("setRankingLoading", true);
    getRanking(idprograma).then(response => {
      const ranking = response.data;
      commit("setRankingLoading", false);
      commit("setRanking", ranking);
    });
  },
  resendEmail({ dispatch, state, commit }, params) {
    const { idprograma, idafiliado } = params;
    resendEmail(idprograma, idafiliado).then(() => {
      dispatch(
        "showSnackbarSuccess",
        i18n.t("sales.affiliates_program_resend_success")
      );
      commit("setAffiliatesToResendEmail", []);
      state.dialogResendEmail = false;
    });
  },
  changeDialogCoupon({ commit, state }, info) {
    if (!state.dialogCoupon) {
      commit("setDialogCoupon", true);
      commit("setInfoDialogCoupon", info);
    } else {
      commit("setDialogCoupon", false);
      commit("setInfoDialogCoupon", null);
    }
  },
  postCoupon({ dispatch, state }, params) {
    const { idprograma, idafiliado, cupom } = params;
    if (cupom.length < 3) {
      dispatch("showSnackbarError", "O cupom deve ter no mínimo 3 caracteres!");
      return;
    }
    postCoupon(idprograma, idafiliado, cupom).then(() => {
      dispatch("showSnackbarSuccess", "Cupom cadastrado com sucesso!");
      state.dialogCoupon = false;
      dispatch("fetchSaleByAffiliateId", { id: idafiliado });
    });
  },
  fetchSalesByAffiliateConsumer({ commit }, params) {
    const { idafiliado, status, pesquisar } = params;
    commit("setLoadingSalesByAffiliateConsumer", true);
    getSalesByAffiliateConsumer(idafiliado, status, pesquisar).then(
      response => {
        const salesByAffiliateConsumer = response.data;
        commit("setLoadingSalesByAffiliateConsumer", false);
        commit("setSalesByAffiliateConsumer", salesByAffiliateConsumer);
      }
    );
  },
};

const mutations = {
  setAllAffiliates: (state, affiliates) => (state.allAffiliates = affiliates),
  setAffiliatesLoading: (state, affiliatesLoading) =>
    (state.affiliatesLoading = affiliatesLoading),

  setAllAffiliatesPrograms: (state, affiliates) =>
    (state.allAffiliatesPrograms = affiliates),
  setAffiliatesProgramsLoading: (state, affiliatesLoading) =>
    (state.affiliatesLoading = affiliatesLoading),

  setStepProgram: (state, stepProgram) => (state.stepProgram = stepProgram),
  setDataProgram: (state, dataProgram) => (state.dataProgram = dataProgram),

  setDialogInsertAffiliates: (state, dialogInsertAffiliate) =>
    (state.dialogInsertAffiliate = dialogInsertAffiliate),
  setDialogResendEmail: (state, dialogResendEmail) =>
    (state.dialogResendEmail = dialogResendEmail),
  toggleDialogEditTicket(state) {
    state.dialogEditTicket = !state.dialogEditTicket;
  },

  setAffiliatesByProgram: (state, affiliatesByProgram) =>
    (state.affiliatesByProgram = affiliatesByProgram),

  setIdProgramTemp: (state, idProgramTemp) =>
    (state.idProgramTemp = idProgramTemp),

  setSale: (state, sale) => (state.sale = sale),
  setSaleLoading: (state, loadingSale) => (state.loadingSale = loadingSale),

  setTerms: (state, terms) => (state.terms = terms),
  setDocTerm: (state, docTerm) => (state.docTerm = docTerm),

  setAffiliateProgramList: (state, affiliateProgramList) =>
    (state.affiliateProgramList = affiliateProgramList),

  setDataPreRegister: (state, dataPreRegister) =>
    (state.dataPreRegister = dataPreRegister),

  setRegisterLoading: (state, registerLoading) =>
    (state.registerLoading = registerLoading),

  setDialogPreRegister: (state, dialogPreRegister) =>
    (state.dialogPreRegister = dialogPreRegister),

  setDialogMyAccount: (state, dialogMyAccount) =>
    (state.dialogMyAccount = dialogMyAccount),

  setRanking: (state, ranking) => (state.ranking = ranking),
  setRankingLoading: (state, loadingRanking) =>
    (state.loadingRanking = loadingRanking),

  setAffiliatesToResendEmail: (state, affiliatesToResendEmail) =>
    (state.affiliatesToResendEmail = affiliatesToResendEmail),
  setTmpIdToResendEmail: (state, tmpIdToResendEmail) =>
    (state.tmpIdToResendEmail = tmpIdToResendEmail),

  setDialogCoupon: (state, dialogCoupon) => (state.dialogCoupon = dialogCoupon),
  setInfoDialogCoupon: (state, infoDialogCoupon) =>
    (state.infoDialogCoupon = infoDialogCoupon),

  setSalesByAffiliateConsumer: (state, salesByAffiliateConsumer) =>
    (state.salesByAffiliateConsumer = salesByAffiliateConsumer),
  setLoadingSalesByAffiliateConsumer: (
    state,
    loadingSalesByAffiliateConsumer
  ) =>
    (state.loadingSalesByAffiliateConsumer = loadingSalesByAffiliateConsumer),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
